import type { RefObject } from 'react'
import { PersonPicker } from '../../../occurrences/components/common/PersonPicker'
import { useAssignableDevelopers } from '../../hooks/useSystemIssues'

/** Painel "Atribuir a…" da fila do HUB (dev): os desenvolvedores que fazem
 * triagem, com busca. Quem atribui é o dono do painel (`onPick`): o painel
 * fecha antes de a resposta chegar, e o aviso de erro precisa de alguém
 * montado para aparecer. */
export function AssignDeveloperPicker({
  currentId,
  anchorRef,
  onPick,
  onClose,
}: {
  currentId: number | null
  anchorRef: RefObject<HTMLElement | null>
  onPick: (developerId: number) => void
  onClose: () => void
}) {
  const { data: developers = [], isLoading, isError } = useAssignableDevelopers()
  return (
    <PersonPicker
      anchorRef={anchorRef}
      onClose={onClose}
      loading={isLoading}
      error={isError}
      currentId={currentId}
      people={developers.map((d) => ({ id: d.id, name: `${d.first_name} ${d.last_name}`.trim() }))}
      onPick={(id) => {
        onClose()
        // O mesmo dev de novo não muda nada (o backend também ignora).
        if (id !== currentId) onPick(id)
      }}
    />
  )
}
